var tutorials =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(151);
	__webpack_require__(587);
	// require('./blocks/rating-stars/rating-stars');
	__webpack_require__(756);
	__webpack_require__(154);
	__webpack_require__(595);
	__webpack_require__(598);
	
	__webpack_require__(159);
	__webpack_require__(757);

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(50);
	
	jQuery(function () {
	    module.exports.params = {
	        infinite: true,
	        adaptiveHeight: true,
	        slidesToScroll: 1,
	        speed: 400
	    };
	
	    module.exports.paramsCssAnim = {
	        cssEase: 'ease',
	        useTransform: true,
	        speed: 600
	    };
	});

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	    // Returns a function, that, as long as it continues to be invoked, will not
	    // be triggered. The function will be called after it stops being called for
	    // N milliseconds. If `immediate` is passed, trigger the function on the
	    // leading edge, instead of the trailing.
	    debounce: function debounce(func, wait, immediate) {
	        var timeout;
	        return function () {
	            var context = this,
	                args = arguments;
	            var later = function later() {
	                timeout = null;
	                if (!immediate) func.apply(context, args);
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) func.apply(context, args);
	        };
	    },
	
	    setResizeDebounce: function setResizeDebounce(func, wait, immediate) {
	        wait = wait || 250;
	        immediate = immediate || false;
	        var thisD = this;
	        var debouncedFunc = thisD.debounce(func, wait, immediate);
	        $(window).resize(debouncedFunc);
	    }
	};

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$defineProperties = __webpack_require__(56)['default'];
	
	module.exports = _Object$defineProperties({}, {
	    defaultFontSize: {
	        get: function get() {
	            var defaultFontSize = parseInt($('html').css('font-size'));
	            if (isNaN(defaultFontSize)) defaultFontSize = 16;
	            return defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobile: {
	        get: function get() {
	            return 20 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    mobileBig: {
	        get: function get() {
	            return 28 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tablet: {
	        get: function get() {
	            return 48 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    tabletBig: {
	        get: function get() {
	            return 60 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    },
	    desktop: {
	        get: function get() {
	            return 76.5 * this.defaultFontSize;
	        },
	        configurable: true,
	        enumerable: true
	    }
	});

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(57), __esModule: true };

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(58);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperties: __webpack_require__(75) });


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(60);
	var core = __webpack_require__(61);
	var ctx = __webpack_require__(62);
	var hide = __webpack_require__(64);
	var has = __webpack_require__(74);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(63);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var createDesc = __webpack_require__(73);
	module.exports = __webpack_require__(69) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var IE8_DOM_DEFINE = __webpack_require__(68);
	var toPrimitive = __webpack_require__(72);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(69) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(69) && !__webpack_require__(70)(function () {
	  return Object.defineProperty(__webpack_require__(71)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(70)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	var document = __webpack_require__(60).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(67);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),

/***/ 74:
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var anObject = __webpack_require__(66);
	var getKeys = __webpack_require__(76);
	
	module.exports = __webpack_require__(69) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(77);
	var enumBugKeys = __webpack_require__(90);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(74);
	var toIObject = __webpack_require__(78);
	var arrayIndexOf = __webpack_require__(82)(false);
	var IE_PROTO = __webpack_require__(86)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(79);
	var defined = __webpack_require__(81);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(80);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),

/***/ 80:
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(78);
	var toLength = __webpack_require__(83);
	var toAbsoluteIndex = __webpack_require__(85);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(84);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),

/***/ 84:
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(84);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(87)('keys');
	var uid = __webpack_require__(89);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(61);
	var global = __webpack_require__(60);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(88) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(119);

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	module.exports = $;

/***/ }),

/***/ 151:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(160);
	__webpack_require__(162);
	__webpack_require__(163);

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(161);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(47)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./jquery.loader.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./jquery.loader.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".mx-loader{display:none;position:fixed;z-index:9999;width:100%;height:100%;left:0;top:0;background:hsla(0,0%,100%,.5)}.mx-loader:after{content:\"\";display:block;z-index:9999;position:absolute;margin:auto;top:0;right:0;bottom:0;left:0;background:url(" + __webpack_require__(162) + ") no-repeat 50%;width:64px;height:64px}", ""]);
	
	// exports


/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "plugins/jquery.loader/img/jquery.loader.gif";

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

	'use strict';
	
	(function ($) {
	    var mxLoader = function mxLoader(options) {
	        var self, _init;
	        var $element, $loader;
	        var defaults = {
	            speed: 200,
	            selector: 'body',
	            block: '<div class="mx-loader"></div>',
	            'class': ''
	        };
	
	        if ($.isPlainObject(options)) {
	            defaults = $.extend(true, defaults, options);
	        }
	
	        self = {
	            init: function init() {
	                if (!_init) {
	                    $element = $(defaults.selector);
	                    $loader = $(defaults.block);
	
	                    defaults = $.extend(true, defaults, options);
	                    isString(defaults['class'], true) && $loader.addClass(defaults['class']);
	
	                    _init = true;
	                }
	
	                return _init;
	            },
	
	            show: function show(speed) {
	                if (self.init()) {
	                    speed = self.speed(speed);
	                    $element.append($loader);
	                    $loader.stop(true).fadeIn(speed);
	                }
	            },
	
	            hide: function hide(speed) {
	                if (self.init()) {
	                    speed = self.speed(speed);
	                    $loader.stop(true).fadeOut(speed, function () {
	                        $loader.detach();
	                    });
	                }
	            },
	
	            speed: function speed(_speed) {
	                return $.isNumeric(_speed) ? parseInt(_speed) | 0 : defaults.speed;
	            }
	        };
	
	        return self;
	    };
	
	    /**
	     * Проверка, является ли переменная строкой
	     * Проверка на не пустаую строку
	     */
	
	    var isString = function isString(variable, noEmpty) {
	        var answer = !!(variable === '' || variable && variable.split);
	        if (noEmpty === true) {
	            answer = answer && variable.length > 0;
	        }
	
	        return answer;
	    };
	
	    window.mxLoader = new mxLoader();
	})(jQuery);

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(309);
	__webpack_require__(311);
	
	var styleSelects = function styleSelects($select) {
	    var overwriteOption = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    $select.each(function () {
	        var $this = $(this);
	
	        var options = {
	            language: 'ru',
	            minimumResultsForSearch: Infinity,
	            dropdownParent: $this.parent()
	        };
	
	        if (!$.isEmptyObject(overwriteOption)) {
	            options = overwriteOption;
	            options.dropdownParent = $this.parent();
	        }
	
	        $this.select2(options).on('select2:open', function () {
	            var $options = $this.parent().find('.select2-container--default .select2-results > .select2-results__options');
	
	            $options.mCustomScrollbar('destroy');
	            $options.mCustomScrollbar('update');
	
	            setTimeout(function () {
	                $options.mCustomScrollbar({
	                    axis: 'y',
	                    scrollbarPosition: 'inside',
	                    advanced: {
	                        updateOnContentResize: true
	                    },
	                    live: true
	                });
	            }, 0);
	        });
	    });
	};
	
	module.exports.styleSelects = styleSelects;

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(312);

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	// ratingStars.js
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(118)['default'];
	
	var _jquery = __webpack_require__(124);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	module.exports = {
	    initRatingStarsList: function initRatingStarsList() {
	
	        var $ratingStars = (0, _jquery2['default'])('.js-rating-stars--inline');
	
	        function loadRatingHover() {
	            $ratingStars.each(function () {
	                var $this = (0, _jquery2['default'])(this);
	                var $stars = $this.find('.rating-stars__star--inline');
	                var $input = $this.find('.rating-stars__hidden-value');
	
	                var curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
	                if (curSelectedVal >= 1) curSelectedVal -= 1;
	
	                $stars.hover(function () {
	                    var $curStar = (0, _jquery2['default'])(this);
	                    var $curStars = $curStar.parent().find('.rating-stars__star--inline');
	                    curSelectedVal = $curStars.filter('.rating-stars__star--filled').length;
	
	                    $curStars.removeClass('rating-stars__star--filled');
	                    $curStar.prevAll('.rating-stars__star--inline').addBack().addClass('rating-stars__star--hover');
	                }, function () {
	                    var $curStar = (0, _jquery2['default'])(this);
	                    var $curStars = $curStar.parent().find('.rating-stars__star--inline');
	
	                    $curStars.removeClass('rating-stars__star--hover');
	                    var arrStars = $curStars.slice(0, curSelectedVal);
	                    arrStars.each(function (idx, el) {
	                        if (!(0, _jquery2['default'])(el).hasClass('js-added-rating')) {
	                            (0, _jquery2['default'])(el).addClass('rating-stars__star--filled');
	                        }
	                    });
	                });
	            });
	        }
	
	        function loadStars() {
	            var elementsId = [];
	
	            $ratingStars.each(function (idx, el) {
	                elementsId.push((0, _jquery2['default'])(el).attr('data-element-id'));
	            });
	
	            _jquery2['default'].ajax({
	                url: '/ajax/action/element_rate/getRatingElements/',
	                data: { 'ids': elementsId },
	                success: function success(result) {
	                    if (result.data) {
	                        var dataArr = result.data;
	
	                        for (var key in dataArr) {
	                            var id = key;
	                            var middleRating = dataArr[key];
	                            var findEl = (0, _jquery2['default'])(".js-rating-stars--inline[data-element-id='" + id + "']");
	                            var stars = findEl.find('.js-rating-item');
	
	                            for (var i = 0; i < stars.length; i++) {
	                                if (i < Math.floor(middleRating)) {
	                                    if (!(0, _jquery2['default'])(stars[i]).hasClass('rating-stars__star--filled')) {
	                                        (0, _jquery2['default'])(stars[i]).addClass('rating-stars__star--filled');
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            });
	        }
	
	        loadStars();
	        loadRatingHover();
	
	        $ratingStars.find('.js-rating-item').on('click', function (e) {
	            e.preventDefault();
	            e.stopPropagation();
	
	            if (!(0, _jquery2['default'])(this).hasClass('js-rating-item')) {
	                return;
	            }
	
	            var $curStar = (0, _jquery2['default'])(this);
	            var elementId = $curStar.parent().attr('data-element-id');
	            var rateEntityId = $curStar.parent().attr('data-rate-entity-id');
	
	            $curStar.prevAll('.js-rating-item').addBack().addClass('rating-stars__star-yellow--filled');
	
	            $curStar.parent().find('.js-rating-item').addClass('js-added-rating');
	
	            _jquery2['default'].ajax({
	                url: '/ajax/action/element_rate/add/',
	                data: 'rating=' + $curStar.parent().find('.rating-stars__star-yellow--filled').length + '&element_id=' + elementId + '&entity_id=' + rateEntityId,
	                success: function success() {
	                    $curStar.parent().find('.js-rating-item').removeClass('js-rating-item rating-stars__star--filled');
	                }
	            });
	        });
	    },
	
	    initRatingStarsDetail: function initRatingStarsDetail() {}
	};

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(175);
	__webpack_require__(159);
	
	jQuery(function () {
	    $('.wrapper').on('click', '.pagination__btn-more', function (event) {
	        event.preventDefault();
	
	        var $this = $(this);
	        var pageCurrent = $this.data('page');
	        $this.parent().parent().remove();
	
	        window.mxLoader && window.mxLoader.show();
	
	        $.ajax({
	            type: 'GET',
	            url: '/ajax/component/maximaster:news.list/.default/',
	            data: {
	                page: pageCurrent
	            },
	            success: function success(response) {
	                window.mxLoader && window.mxLoader.hide(0);
	
	                if (response.code === 200) {
	                    var newSection = $(response.html);
	                    $('.js-grid-news:last').append(newSection[0].innerHTML);
	                    $('.js-grid-news:last').append(newSection[1].outerHTML);
	                } else {
	                    console.error(response.message);
	                }
	            },
	            dataType: 'json'
	        });
	
	        return false;
	    });
	    $('.js-news-block').on('click', function () {
	        var link = $(this).find('a').attr('href');
	        window.location.href = link;
	    });
	});

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slickDefaults = __webpack_require__(49);
	var debounce = __webpack_require__(52);
	__webpack_require__(599);
	
	var size = __webpack_require__(55);
	
	jQuery(function () {
	    $('.js-brochure-slider').slick($.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
	        slidesToShow: 3,
	        responsive: [{
	            breakpoint: size.tabletBig,
	            settings: { slidesToShow: 2 }
	        }, {
	            breakpoint: size.tablet,
	            settings: { slidesToShow: 1 }
	        }]
	    }));
	
	    var $slider = $('.js-brochure-slider-vertical');
	
	    if ($slider.length > 0) {
	        var verticalBrochureSliderOptions = $.extend({}, slickDefaults.params, {
	            slidesToShow: 3,
	            vertical: true,
	            verticalSwiping: false,
	            responsive: [{
	                breakpoint: size.tablet,
	                settings: { slidesToShow: 1, vertical: false }
	            }]
	        });
	
	        $slider.slick(verticalBrochureSliderOptions);
	
	        resizeVerticalBrochureSlider($slider);
	
	        debounce.setResizeDebounce(function () {
	            resizeVerticalBrochureSlider($slider);
	        });
	    }
	
	    //подогнать высоту слайдера под высоту основного контента
	    function resizeVerticalBrochureSlider($slider) {
	        if (window.innerWidth < size.tablet) return false;
	
	        var $mainColumn = $('#brochures-list-main-column');
	        var $mainColumnAddition = $('#main-column-addition');
	
	        if (window.innerWidth < size.desktop) $mainColumnAddition.insertAfter($mainColumn);else $mainColumn.append($mainColumnAddition);
	
	        var mainColumnHeight = $mainColumn.height();
	        var brochureHeight = $slider.find('.brochure-slider__item').first().innerHeight();
	        var slideCount = 3;
	
	        if (mainColumnHeight > brochureHeight * 3) slideCount = Math.round(mainColumnHeight / brochureHeight) - 1;
	
	        var curSlideCount = $slider.get(0).slick.options.slidesToShow;
	
	        if (curSlideCount != slideCount) {
	            $slider.slick('unslick');
	            $slider.slick($.extend({}, verticalBrochureSliderOptions, {
	                slidesToShow: slideCount
	            }));
	        }
	    }
	});

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

	// ratingStars.js
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(118)["default"];
	
	var _jquery = __webpack_require__(124);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _modulesRatingInline = __webpack_require__(574);
	
	(0, _jquery2["default"])(document).ready(function () {
	   (0, _modulesRatingInline.initRatingStarsList)();
	});

/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _modulesRatingInline = __webpack_require__(574);
	
	var styleSelects = __webpack_require__(308);
	__webpack_require__(758);
	
	$(function () {
	    styleSelects.styleSelects($('.js-styled-select'));
	
	    /**
	     * Обработка Ajax перезагрузки компонента
	     * @param element
	     */
	
	    var ajaxComponent = function ajaxComponent(element) {
	        window.mxLoader = window.mxLoader || undefined;
	
	        var $this = $(element);
	        var $container = $this.closest('.js-ajax-component');
	
	        if ($container.length === 1) {
	            var ajax = $container.data('ajax');
	            var url = ajax['URL'] ? ajax['URL'] : null;
	            var parameters = ajax['PARAMETERS'] ? ajax['PARAMETERS'] : null;
	            var data = {};
	
	            if (!url) {
	                return;
	            }
	
	            if ($this.is('input') || $this.is('select')) {
	                // Перезагрузку вызвал инпут
	                data[element.name] = element.value;
	            } else if ($this.hasClass('pagination__item')) {
	                // Перезагрузку вызвал элемент постраничной навигации
	                if ($this.hasClass('pagination__item--current')) {
	                    return;
	                }
	
	                var href = $this.attr('href');
	                var matches = href && href.match ? href.match(/page=([\d]+)/) : [];
	
	                data['page'] = matches ? parseInt(matches[1]) | 0 || 1 : 1;
	            }
	
	            var time = new Date().getTime() + 500;
	            $('body, html').animate({ scrollTop: $container.offset().top - 15 }, 400);
	            window.mxLoader && window.mxLoader.show();
	
	            $.ajax({
	                url: url + '?' + $.param(parameters),
	                data: data,
	                type: 'get',
	                success: function success(result) {
	                    if (result && result.html) {
	                        time = time - new Date().getTime();
	                        time = time > 0 ? time : 0;
	
	                        var $block, $select;
	                        var $html = $(result.html);
	                        $html.each(function () {
	                            $block = $(this);
	                            if ($block.hasClass('js-ajax-component')) {
	                                var ajax = $block.data('ajax');
	                                var get = ajax['GET'] ? $.param(ajax['GET']) : null;
	                                var parameters = ajax['PARAMETERS'] ? ajax['PARAMETERS'] : null;
	
	                                // Стилизация селектов
	                                $select = $('.js-styled-select', $block);
	                                $select && styleSelects.styleSelects($select);
	
	                                // Установка нового адреса страницы
	                                if (parameters && parameters['SET_URL'] !== 'N') {
	                                    history && history.pushState && history.pushState(null, '', get ? '?' + get : window.location.pathname);
	                                }
	
	                                return false;
	                            }
	                        });
	
	                        setTimeout(function () {
	                            $container.replaceWith($html);
	                            (0, _modulesRatingInline.initRatingStarsList)();
	                            window.mxLoader && window.mxLoader.hide();
	                        }, time);
	                    }
	                }
	            });
	        }
	    };
	
	    // Обработка при изменении значения фильтра или количества элементов
	    $(document).on('change', '.js-ajax-component input, .js-ajax-component select', function () {
	        ajaxComponent(this);
	    });
	
	    // Обработка при клике на элемент постраничной навигации
	    $(document).on('click', '.js-ajax-component .pagination__item', function (event) {
	        event.preventDefault();
	        ajaxComponent(this);
	    });
	});

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/tutorials.a57aac900537262ae4fe.js